import { createAction } from 'redux-actions';
import {
  getColorByVariantPaperColor as getColorByMaterialVariantPaperColor,
  getColorByVariantRibbonColor as getColorByMaterialVariantRibbonColor
} from "pxc-editor-core/helpers/material";
import {
  SET_COLOR_SCHEMA,
  SET_RIBBON_COLOR,
  SET_PAPER_COLOR,
} from '@/constants';
import { addSectionsAction } from '@/actions/section';
import { changeContentColor } from '@/helpers';

const setRibbonColor = color => createAction(SET_RIBBON_COLOR, () => color)();

const setPaperColor = color => createAction(SET_PAPER_COLOR, () => color)();

const setColorSchemaAction = schema => createAction(SET_COLOR_SCHEMA, () => schema)();

export const changeColorSchemaThunk = (payload) => (dispatch, getState) => {
  const { schema, paperColor, ribbonColor } = payload;
  const { core: { pages } } = getState();

  dispatch(setColorSchemaAction(schema));
  dispatch(setPaperColor(paperColor));
  dispatch(setRibbonColor(ribbonColor));

  for(const pUid in pages) {
    const currentPage = pages[pUid];
    const sections = Object.entries(currentPage.sections).reduce((acc, [key, value]) => {
      return { ...acc, [key]: { ...value, ...changeContentColor(ribbonColor) } };
    }, {});

    dispatch(addSectionsAction({ [currentPage.uid]: { ...currentPage, sections } }));
  }
};

export const setInitColorSchemaThunk = schema => (dispatch, getState) => {
  const newPaperColor = getColorByMaterialVariantPaperColor(schema);
  const newRibbonColor = getColorByMaterialVariantRibbonColor(schema);

  dispatch(setColorSchemaAction(schema));
  dispatch(setPaperColor(newPaperColor));
  dispatch(setRibbonColor(newRibbonColor));
};
